import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgxEchartsModule } from 'ngx-echarts';

import { StatBarchartComponent } from './stat-barchart/stat-barchart.component';
import { StatLinechartComponent } from './stat-linechart/stat-linechart.component';
import { StatPiechartComponent } from './stat-piechart/stat-piechart.component';
import { StatTableComponent } from './stat-table/stat-table.component';

@NgModule({
  declarations: [
    StatBarchartComponent,
    StatLinechartComponent,
    StatPiechartComponent,
    StatTableComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  exports: [
    StatBarchartComponent,
    StatLinechartComponent,
    StatPiechartComponent,
    StatTableComponent,
  ],
})
export class StatisticsModule {}
